import Vue from "vue"
import { formatDate } from '@/utils/date'


Vue.filter("first4Chars", str => str.substring(0, 4))

Vue.filter('formatDateTime', function (time) {
    if (time == null || time === '') {
        return 'N/A';
    }
    // let date = new Date(time);
    // return formatDate(date, 'yyyy/MM/dd hh:mm')
    let date = new Date(time);

    const hours = date.getHours();
    const minutes = date.getMinutes();

    // Determine AM or PM
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // Convert to 12-hour format
    const formattedHours = hours % 12 || 12;  // '0' hours should display as '12'

    // Format minutes to always show two digits
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;

    // Format the final date and time
    const formattedDate = formatDate(date, 'yyyy/MM/dd');

    return `${formattedDate} ${formattedHours}:${formattedMinutes} ${ampm}`;
})

Vue.filter('formatDate', function (time) {
    if (time == null || time === '') {
        return 'N/A';
    }
    let date = new Date(time);
    return formatDate(date, 'yyyy/MM/dd')
})

Vue.filter('toDefaultCurrency', function (value) {
    if (typeof value !== "number") {
        return value
    }
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    })
    return formatter.format(value)
})

Vue.filter('toLakhCurrency', function (value) {
    if (!value) return '';
      const num = Number(value);
      return num.toLocaleString('en-US', { maximumFractionDigits: 0 });
})

Vue.filter('toLakh', function (value) {
    if (typeof value !== "number") {
        return value
    }
    return (value / 100000).toFixed(3) + ' Lks';
});